import { isNil } from '@/utils/is-nil';

export const typedObjectKeys = <T extends object>(obj: T) => {
  if (isNil(obj)) {
    return [];
  }

  return Object.keys(obj) as Array<keyof T>;
};
